// extracted by mini-css-extract-plugin
export default {"main":"navbar_main__2YqCQ","leftDiv":"navbar_leftDiv__uNrUP","logo":"navbar_logo__9WcZt","nav":"navbar_nav__+Nqfj"};